import SessionLoadingPage from './SessionLoadingPage';

export default SessionLoadingPage;
